export default "__VITE_ASSET__ajofH1la__"